export const THEWEST_ALL = 'thewest:all'
